import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'

import BookingContext from '../contexts/booking'
import useBooking from '../hooks/useBooking'
import routerActions from '@kaidam/fc-shared/src/frontend/store/modules/router'

import BookingSummary from '../components/booking/Summary'
import BookingStepper from '../components/booking/Stepper'

import linkSelectors from '../store/selectors/link'

const BookingLayout: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const dispatch = useDispatch()
  const booking = useBooking()
  const fullRoute = useSelector(linkSelectors.fullRoute) as any

  return (
    <BookingContext.Provider value={booking}>
      <Container 
        maxWidth="lg" 
        sx={(theme) => ({
          padding: theme.spacing(2),
        })}
      >
        <Paper 
          sx={(theme) => ({
            width: '100%',
            padding: theme.spacing(3),
            marginBottom: theme.spacing(2),
          })}
        >
          {
            fullRoute.meta?.showSteps && (
              <>
                <BookingStepper />
                <Divider sx={(theme) => ({
                  marginTop: theme.spacing(1),
                  marginBottom: theme.spacing(1),
                })} />
              </>
            )
          }
          <BookingSummary
            overrideTitle={ fullRoute.meta?.bookingSummaryTitle }
          />
          <Divider sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
          })} />
          { children }
        </Paper>
        {
          booking.generalConfig && (booking.generalConfig.contact_email || booking.generalConfig.contact_phone) && (
            <Paper sx={(theme) => ({
              width: '100%',
              padding: theme.spacing(3),
              marginBottom: theme.spacing(2),
            })}>
              <Typography variant="h6" gutterBottom>
                Get in touch
              </Typography>
              <Typography variant="body1" gutterBottom>
                If you are having any problems making your booking or want to get in touch with us for another reason, please use the following details:
              </Typography>
              <Typography variant="body1" gutterBottom component="div">
                <ul>
                  {
                    booking.generalConfig.contact_email && (
                      <li>
                        <strong>Email: </strong> { booking.generalConfig.contact_email }
                      </li> 
                    )
                  }
                  {
                    booking.generalConfig.contact_phone && (
                      <li>
                        <strong>Phone: </strong> { booking.generalConfig.contact_phone }
                      </li> 
                    )
                  }
                </ul>
              </Typography>
            </Paper>
          )
        }
        
      </Container>
    </BookingContext.Provider>
  )
}

export default BookingLayout